import { render } from "./CustomerServiceChat.vue?vue&type=template&id=7b1817aa&scoped=true"
import script from "./CustomerServiceChat.vue?vue&type=script&lang=js"
export * from "./CustomerServiceChat.vue?vue&type=script&lang=js"

import "./CustomerServiceChat.vue?vue&type=style&index=0&id=7b1817aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@5.110.3_cssnano@5.1.15_postcss@8.5.28__postcss@8.5.28_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b1817aa"]])

export default __exports__